'use client';

import { usePathname } from 'next/navigation';
import { useState, useEffect } from 'react';

interface FooterProps {
  className?: string;
}

const Footer = ({ className = '' }: FooterProps) => {
  const pathname = usePathname();
  const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    setMounted(true);
  }, []);
  
  // Determine current language - English, French, and Arabic
  // Use safe defaults during initial render
  const isFrench = mounted && (pathname?.includes('-french') || pathname?.includes('/propos')) || false;
  const isArabic = mounted && pathname?.startsWith('/ar') || false;

  // Footer content based on language
  const getFooterContent = () => {
    if (isArabic) {
      return {
        subtitle: 'التحكيم الدولي والحل الاستراتيجي للمنازعات',
        address: '62 شارع دو كومارتان',
        postalCode: '75009',
        city: 'باريس',
        country: 'فرنسا',
        copyright: `جميع الحقوق محفوظة. ©`
      };
    } else if (isFrench) {
      return {
        subtitle: 'Arbitrage international & résolution stratégique des différends',
        address: '62 Rue de Caumartin',
        postalCode: '75009',
        city: 'Paris',
        country: 'France',
        copyright: 'Tous droits réservés.'
      };
    } else {
      return {
        subtitle: 'International Arbitration & Strategic Dispute Resolution',
        address: '62 Rue de Caumartin',
        postalCode: '75009',
        city: 'Paris',
        country: 'France',
        copyright: 'All rights reserved.'
      };
    }
  };

  const content = getFooterContent();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`bg-gradient-to-br from-[#0E3B3C] via-[#0E3B3C] to-[#1a5658] text-primary-foreground py-16 px-8 border-t border-border ${className}`}>
      <div className="max-w-7xl mx-auto">
        {/* Single text block - left aligned, editorial style */}
        <div className="space-y-6 max-w-xl" style={isArabic ? { direction: 'ltr' } : {}}>
          {/* Firm Name */}
          <div className="text-2xl font-medium tracking-tight">
            ND LAW
          </div>
          
          {/* Subtitle */}
          <div className="text-base font-light opacity-90 leading-relaxed">
            {content.subtitle}
          </div>
          
          {/* Contact Information */}
          <div className="space-y-2 text-sm font-light opacity-75 leading-relaxed">
            <div>{content.address}</div>
            <div>{content.postalCode}</div>
            <div>{content.city}</div>
            <div>{content.country}</div>
            <div className="pt-2">
              <a 
                href="mailto:contact@ndlaw.fr" 
                className="hover:opacity-100 transition-opacity"
              >
                contact@ndlaw.fr
              </a>
            </div>
          </div>
          
          {/* Copyright */}
          <div className="pt-4 text-xs font-light opacity-60">
            &copy; {currentYear} ND LAW. {content.copyright}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;